module.exports = "<h4 mat-dialog-title>{{title}}</h4>\n<mat-dialog-content>{{body}}</mat-dialog-content>\n<mat-dialog-actions>\n  <button mat-raised-button mat-dialog-close (click)=\"onClick()\" color=\"accent\">OK</button>\n</mat-dialog-actions>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dialog/dialog.component.html
// module id = ./src/app/dialog/dialog.component.html
// module chunks = main